export enum QuoteFileIdType {
  MarketQuote = 'marketQuoteFileIds',
  Binder = 'binderFileIds',
  Policy = 'policyFileIds',
}
